import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { memo, useEffect, useRef, useState } from "react";
import { useReport } from "../../context/report";
import { useReactToPrint } from "react-to-print";

export default memo(function Artigo() {
    const [total, setTotal] = useState(0);
    const [printing, setPrinting] = useState(false);

    const { data } = useReport();
    const ref = useRef();

    const options = {
        width: 100 / 4 + '%'
    }

    const handlePrint = useReactToPrint({
        content: () => ref.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                setPrinting(true);
                setTimeout(() => {
                    resolve();
                }, 500);
            });
        },
        onAfterPrint: () => {
            setPrinting(false);
        }
    });
    
    useEffect(() => {
        let total = 0;
        data.forEach((element) => {
            total += parseFloat(element.total);
        });
        setTotal(total);
    }, [data]);

    return (
        <>
            <h3>Total: {Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(total)}</h3>
            <Button
                className="p-m-1"
                icon="pi pi-print"
                onClick={handlePrint}
            />
            <DataTable
                ref={ref}
                filterDisplay={printing === false ? "row" : ""}
                responsiveLayout="scroll"
                value={data}
            >
                <Column header="Artigo" filter={printing === false ? true : false} sortable field="artigo" style={options} />
                <Column header="Metragem" sortable sortField="total" style={options} body={(rowData) => {
                    return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowData.total)
                }} />
                <Column header="Meta" sortable sortField="meta" style={options} body={(rowData) => {
                    return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowData.meta);
                }} />
                <Column header="%" sortable style={options} body={(rowData) => {
                    return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowData.porcentagem) + "%";
                }} />
            </DataTable>
        </>
    )
});